import type { OctopusFeatureToggle } from "@octopusdeploy/octopus-server-client";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useOctopusFeatureToggle(toggle: OctopusFeatureToggle, defaultValue: boolean) {
    return useBooleanFlagValue(toggle, defaultValue);
}
